import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'full-screen-overlay',
    templateUrl: './full-screen-overlay.component.html',
    styleUrls: ['./full-screen-overlay.component.css'],
    standalone: false
})
export class FullScreenOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
